import Vue from 'vue'
import Vuex from 'vuex'
import auth from './Auth'
import user from './Users'
import config from './modules/config'
import company from './Company'
import transaction from './Transactions'
import visits from './Visits'
import product from './modules/product'
import category from './modules/category'
import conditions from './modules/conditions'
import home from './modules/home'
import werehouse from './modules/werehouse'
import inventory from "./modules/inventory"
import cart from "./modules/cart"
import words from './modules/words'
import tickets from "./modules/tickets"
// import exchange from './modules/exchange'
import advertising from './modules/advertising'
import settings from './Settings'
import promotions from './Promotions'
import exchange from "./Exchange"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    config,
    company,
    product,
    category,
    conditions,
    home,
    werehouse,
    inventory,
    cart,
    words,
    tickets,
    exchange,
    advertising,
    transaction,
    visits,
    settings,
    promotions
  },
  state: {
     showInfo: {},
     theme: "",
     country: ''
  },
  mutations: {
     SET_SHOW_INFO(state, payload){
      state.showInfo = payload
    },
     SET_THEME(state, payload){
      state.theme = payload
    },
    SET_COUNTRY(state, payload){
      state.country = payload
    }
  },
  actions: {},

  getters: {
     getShowInfo : state => state.showInfo,
     getTheme : state => state.theme,
     getCountry : state => state.country

  },
})
